<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon crd-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">Update Profile</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="firstname"
                      >Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstname"
                      formControlName="firstname"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('firstname')"
                    >
                      The name is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="lastname"
                      >Last Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="lastname"
                      formControlName="lastname"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      The last name is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="identification"
                      >Identification</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="identification"
                      formControlName="identification"
                      [readOnly]="id"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="rut"
                      >S.S / RUT</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="rut"
                      formControlName="rut"
                      [readOnly]="id"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="indicative"
                      >Indicative</label
                    >
                    <select
                      class="form-control select"
                      id="indicative"
                      formControlName="indicative"
                    >
                      <option value="" disabled>Select a indicative</option>
                      <option *ngFor="let item of indicatives" [value]="item">
                        {{ item }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('indicative')"
                    >
                      Indicative is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="phone">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      (input)="formatPhone($event)"
                    />
                    <!-- (keyup)="formatPhone()" -->
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('phone')"
                    >
                      Phone is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="address"
                      >Address</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      formControlName="address"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('address')"
                    >
                      Address is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="apt">Apt</label>
                    <input
                      type="text"
                      class="form-control"
                      id="apt"
                      formControlName="apt"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('city')"
                    >
                      City is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="state">State</label>
                    <input
                      type="text"
                      class="form-control"
                      id="state"
                      formControlName="state"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('state')"
                    >
                      State is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="country"
                      >Country</label
                    >
                    <select
                      class="form-control select"
                      id="country"
                      formControlName="country"
                    >
                      <option value="" disabled>Select a country</option>
                      <option *ngFor="let item of countries" [value]="item">
                        {{ item }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('country')"
                    >
                      Country is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="username"
                      >Email</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="username"
                      formControlName="username"
                    />
                  </div>
                  <div
                    class="invalid-feedback"
                    *ngIf="isFieldInvalid('username')"
                  >
                    Email is required
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="password"
                      >Password</label
                    >
                    <div class="d-flex">
                      <input
                        [type]="showPassword ? 'text' : 'password'"
                        class="form-control"
                        id="password"
                        formControlName="password"
                      />
                      <div class="input-group-append">
                        <span
                          class="input-group-text"
                          style="cursor: pointer"
                          (click)="togglePasswordVisibility()"
                        >
                          <i class="material-icons">{{
                            showPassword ? "visibility_off" : "visibility"
                          }}</i>
                        </span>
                      </div>
                    </div>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('password')"
                    >
                      Password is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <!-- <label class="bmd-label-floating" for="img"
                      >Select image</label
                    > -->
                    <a
                      (click)="selectFile()"
                      [class.disabled]="upload"
                      [style.pointer-events]="upload ? 'none' : 'auto'"
                      [style.opacity]="upload ? '0.5' : '1'"
                      style="
                        cursor: pointer;
                        text-decoration: underline;
                        color: #007bff;
                      "
                    >
                      Select photo
                      <input
                        #fileInput
                        type="file"
                        (change)="captureFile($event)"
                        style="display: none"
                        accept="image/*"
                      />
                    </a>
                    <span *ngIf="upload"> (Uploaded) </span>
                    <button
                      *ngIf="upload"
                      type="button"
                      class="btn btn-dark btn-sm btn-update"
                      (click)="removeFile('img')"
                    >
                      X
                    </button>
                  </div>
                </div>
                <!-- <div class="col-md-4">
                  <div class="form-group">
                    <a
                      (click)="selectFileTwo()"
                      [class.disabled]="upload_two"
                      [style.pointer-events]="upload_two ? 'none' : 'auto'"
                      [style.opacity]="upload_two ? '0.5' : '1'"
                      style="
                        cursor: pointer;
                        text-decoration: underline;
                        color: #007bff;
                      "
                    >
                      Select identification
                      <input
                        #fileInputTwo
                        type="file"
                        (change)="captureFileTwo($event)"
                        style="display: none"
                        accept="image/*"
                      />
                    </a>
                    <span *ngIf="upload_two"> (Uploaded) </span>
                    <button
                      *ngIf="upload_two"
                      type="button"
                      class="btn btn-dark btn-sm btn-update"
                      (click)="removeFile('imgIdentification')"
                    >
                      X
                    </button>
                  </div>
                </div> -->
              </div>
              <br />
              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid"
                  >
                    Update
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-body">
            <br />
            <img
              [src]="getProfileImgUrl('img')"
              class="imgs"
              alt="Driver Image"
            />
          </div>
          <div class="card-body">
            <br />
            <img
              [src]="getProfileImgUrl('imgIdentification')"
              class="img__identification"
              alt="Identification Image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
